export default __webpack_public_path__ + "static/media/LENS_CULINARIS_GDM_7.55726696.jpg";